import { ANALYTICS_SERVICE_ROUTING } from 'lib/@getethos/experiments/feature_constants'

export const getAnalyticsServiceVariation = () => {
  const analyticsServiceVariationRaw = sessionStorage.getItem(
    ANALYTICS_SERVICE_ROUTING.name
  )

  if (!analyticsServiceVariationRaw) {
    return {
      isControl: true,
      isHybrid: false,
      isService: false,
    }
  }

  try {
    const analyticsServiceVariation = JSON.parse(
      analyticsServiceVariationRaw
    ).variationKey

    return {
      isControl:
        analyticsServiceVariation ===
          ANALYTICS_SERVICE_ROUTING.variations.control ||
        analyticsServiceVariation === ANALYTICS_SERVICE_ROUTING.variations.off,
      isHybrid:
        analyticsServiceVariation ===
        ANALYTICS_SERVICE_ROUTING.variations.hybrid,
      isService:
        analyticsServiceVariation ===
        ANALYTICS_SERVICE_ROUTING.variations.service,
    }
  } catch (error) {
    console.error('Error parsing analytics service variation', error)
    return {
      isControl: true,
      isHybrid: false,
      isService: false,
    }
  }
}
